import { useSearchParams } from 'react-router-dom';

import { FORM_ID } from 'constants/form-ids';
import { SEARCH_PARAMS } from 'constants/search-params';
import { LoadDataContainer } from 'views/app/load-data-container';

import { PAGE_CONFIG } from '../page-config';

const InvoicePage = () => {
  const [searchParams] = useSearchParams();
  const formId = searchParams.get(SEARCH_PARAMS.CUSTOM_FORM) || '';
  const formKey = FORM_ID[formId] || 'default';

  const { BaseCard } = PAGE_CONFIG[formKey];

  return (
    <LoadDataContainer formKey={formKey}>
      <BaseCard />
    </LoadDataContainer>
  );
};

export default InvoicePage;
